<template>
  <activity-view
    action-label="checked in"
    :award-context="awardContext"
    :created-at="activity.checkin.createdAt"
    :show-entity-info="showEntityInfo"
    :show-team-org-name="showTeamOrgName"
    :activity="activity"
    :theme-color="themeColor"
    :comment="activity.comment"
    :goal="goal"
    @awarded="$emit('awarded')"
    @reacted="$emit('reacted')"
  >
    <checkin-values class="check-values mt-1" :checkin="activity.checkin" :kr="kr" />
  </activity-view>
</template>

<script>
import ActivityView from '@/components/activity/ActivityView'
import CheckinValues from '@/components/CheckinValues'
import { ENTITY_TYPE } from '@/constants/entities'
import getEventAwardContext from '@/utils/getEventAwardContext'

/**
 * This component gives view for checkin activity
 */
export default {
  name: 'CheckinActivity',
  props: ['activity', 'kr', 'showEntityInfo', 'themeColor', 'showTeamOrgName', 'goal'],
  components: {
    CheckinValues,
    ActivityView
  },
  data() {
    return {
      awardContext: getEventAwardContext(this.activity, ENTITY_TYPE.GOAL, this.kr.title)
    }
  }
}
</script>

<style lang="scss" scoped>
.meta {
  margin-left: 38px;
}
</style>
